import React from 'react'
import './Spinner.css'

const Spinner = () => {
  return (
    <div className="custom-loader-container">
      <div className="custom-loader"></div>
    </div>
  )
}

export default Spinner
